
































































import {Component, Vue, Prop} from "vue-property-decorator";
import {Column, Message} from "../../types/core";
import LoraWanUpdateView from "@/components/LoraWanUpdateView.vue";
import TruncatedString from "@/components/TruncatedString.vue";
import MobileFriendlyRow from "@/components/MobileFriendlyRow.vue";

@Component({components:{
    MobileFriendlyRow,
    LoraWanUpdateView,
  }
})

export default class MessageMobile extends Vue {

  @Prop({ default: () => {},  type: Object}) message!:Message;
  @Prop({ default: 0,  type: Number}) index!: number;
  expand:boolean = false;
  pressTimer:any = null;
  payloadLength=20;

  cols:Column[] = [
    { colKey: 'ts',
      colName:'time',
      colStyle:{width: '30%','align-self': 'center'}
    },
    { colKey: 'type',
      colName:'type',
      colStyle:{  width: '10%', 'align-self': 'center', 'text-align': 'center'}
    },
    { colKey: 'port',
      colName:'port',
      colStyle:{  width: '10%', 'align-self': 'center', 'text-align': 'center'}
    },
    {
      colKey: 'hexPayload',
      colName: 'payload size',
      colStyle: {width: '40%', 'align-self': 'center'}
    }

  ]

  startToggleTimer(evt:any){
    this.pressTimer = setTimeout(()=>{
        evt.preventDefault()
        this.pressTimer = null
    },100)
  }

  toggleExpansion(){
      this.expand = !this.expand
  }

  maybeToggleExpansion(){
    if(this.pressTimer){
      clearTimeout(this.pressTimer)
      this.toggleExpansion()
    }
  }

  getLoraPort(message:Message):string|number {

      if(message.port)
          return message.port;

      if(message.network && message.network.loraWan)
          return message.network.loraWan.loraPort;

      return 'N/A';
  }
}

